import { render } from "./ToolbarButton.vue?vue&type=template&id=6472e788"
import script from "./ToolbarButton.vue?vue&type=script&lang=js"
export * from "./ToolbarButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Toolbar/ToolbarButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6472e788"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6472e788', __exports__)) {
    console.log('reload')
    api.reload('6472e788', __exports__)
  }
  
  module.hot.accept("./ToolbarButton.vue?vue&type=template&id=6472e788", () => {
    console.log('re-render')
    api.rerender('6472e788', render)
  })

}


export default __exports__